import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL: /en/white-papers/<slug> moved to /en/downloads/<slug>.
// Thrown from beforeLoad so SSR answers with a real HTTP redirect.
export const Route = createFileRoute("/en/white-papers/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/en/downloads/$slug",
      params: { slug: params.slug },
      replace: true,
      statusCode: 301,
    });
  },
});
